<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (hasNotInvestment()) {
      <info [option]="optionInfo1">
        Vous devez saisir une répartition pour au moins un support pour pouvoir
        continuer.
      </info>
    }
    @if (!hasNotInvestment() && getTotalToRepart() !== 0) {
      <info [option]="optionInfo1">
        Il vous reste {{ getTotalToRepart() }} € à répartir entre les supports.
      </info>
    }
    <div class="bloc-btns">
      <div class="bloc-btns-grid">
        <pr-button
          size="lg"
          type="button"
          display="neutral"
          rightIcon="sp-plus"
          label="Ajouter un support"
          rounded
          (onClick)="addSupport()"
        ></pr-button>
      </div>
    </div>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let i = $index) {
        @if (i == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <ng-container formArrayName="supportRepartition">
                <div class="row">
                  <div class="col-md-12">
                    <pr-panel>
                      <div class="man pr-panel">
                        <pr-panel-body>
                          <div class="pr-panel-body">
                            <div
                              class="pr-card-swiper animated fadeIn relative overflow-hidden"
                            >
                              <table
                                class="pr-table-card-container"
                                style="width: 100%"
                              >
                                <tbody class="pr-table-card-statistics-body">
                                  <ng-container>
                                    <div
                                      class="pr-table-card-row ng-star-inserted"
                                    >
                                      @for (
                                        support of supportRepartition.controls;
                                        track support;
                                        let j = $index
                                      ) {
                                        <ng-container [formGroupName]="j">
                                          @if (j === 0) {
                                            <div
                                              class="pointer pr-table-card-row-container"
                                            >
                                              <div
                                                class="pr-table-card-cell grid-span-3 text-ellipsis"
                                              >
                                                <span
                                                  class="label-table bold text-ellipsis"
                                                >
                                                  Nom du support
                                                </span>
                                              </div>
                                              <div
                                                class="pr-table-card-cell grid-span-2 text-ellipsis"
                                              >
                                                <span
                                                  class="label-table bold text-ellipsis"
                                                >
                                                  ISIN
                                                </span>
                                              </div>
                                              <div
                                                class="pr-table-card-cell grid-span-2 text-ellipsis"
                                              >
                                                <span
                                                  class="label-table bold text-ellipsis"
                                                >
                                                  Valorisation en €
                                                </span>
                                              </div>
                                              <div
                                                class="pr-table-card-cell grid-span-1 text-ellipsis"
                                              >
                                                <span
                                                  class="label-table bold text-ellipsis"
                                                >
                                                  Action
                                                </span>
                                              </div>
                                            </div>
                                          }
                                          <div
                                            class="pointer pr-table-card-row-container"
                                          >
                                            <div
                                              class="pr-table-card-cell grid-span-3 text-ellipsis"
                                            >
                                              <span
                                                class="label-table text-ellipsis"
                                              >
                                                {{
                                                  support.get('supportName')
                                                    ?.value
                                                }}
                                              </span>
                                            </div>
                                            <div
                                              class="pr-table-card-cell grid-span-2 text-ellipsis"
                                            >
                                              <span
                                                class="label-table text-ellipsis"
                                              >
                                                {{ support.get('isin')?.value }}
                                              </span>
                                            </div>
                                            <div
                                              class="pr-table-card-cell grid-span-2 text-ellipsis"
                                            >
                                              <div
                                                class="d-flex"
                                                style="max-width: 300px"
                                              >
                                                <input
                                                  eaNumericInput
                                                  type="text"
                                                  class="full-w percent"
                                                  formControlName="amount"
                                                />
                                                <span style="margin-left: 3px"
                                                  >€</span
                                                >
                                              </div>
                                            </div>
                                            <div
                                              class="pr-table-card-cell grid-span-1 text-ellipsis"
                                            >
                                              <pr-button-confirm
                                                display="danger"
                                                clazz="pr-toolbar-button last"
                                                size="sm"
                                                variant="outline"
                                                icon="delete_outline"
                                                title="Suppression"
                                                comment="Toute suppression est définitive, les données seront perdues."
                                                labelConfirm="Supprimer"
                                                labelCancel="Annuler"
                                                (onConfirm)="
                                                  onSupportDeselect(
                                                    support.value
                                                  )
                                                "
                                              >
                                                Êtes-vous sûr(e) de vouloir
                                                supprimer le support :
                                                <em
                                                  >“{{
                                                    support.get('isin')?.value
                                                  }}”</em
                                                >
                                              </pr-button-confirm>
                                            </div>
                                          </div>
                                        </ng-container>
                                      }
                                    </div>
                                  </ng-container>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </pr-panel-body>
                      </div>
                    </pr-panel>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
    [disabledNext]="disabledNextBtn()"
  ></form-footer>
</form>
<pr-modal
  clazz="pr-modal-confirm"
  display="neutral custom-modal-width"
  #modalSupport
>
  <div class="pr-modal-confirm-header d-flex align-items-center gap-s mbl">
    <pr-icon name="sp-plus"></pr-icon>
    <h4 class="man bold">Ajouter des supports</h4>
  </div>
  <form [formGroup]="criteriaSupportForm">
    <pr-input-abstract
      label="Type de support"
      class="mvl"
      style="display: block"
    >
      <mat-select formControlName="supportTypes" placeholder="Tous">
        <mat-option [value]="undefined">Tous</mat-option>
        @for (type of supportTypes | async; track type) {
          <mat-option [value]="type.id">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </pr-input-abstract>
    <pr-input-radio
      formControlName="enableViewAll"
      columns="3"
      [toggle]="true"
      [isDefault]="true"
      label="Voir les produits structurés expirés"
    >
    </pr-input-radio>

    <pr-search-input
      formControlName="autocomplete"
      placeholder="Rechercher un support"
      class="mbm"
    >
    </pr-search-input>
  </form>
  <pr-form-select-list #formSelectList>
    @for (support of supports; track support) {
      <pr-form-select-list-option
        [label]="support.name"
        [labelIcon]="support.favorite ? 'sp-cup' : undefined"
        [subLabel]="support.isin"
        [criteriasLoading]="criteriasLoading"
        [selected]="getSupportInvestment(support.isin)"
        [criterias]="[
          {
            label: 'Performance sur 1 an',
            value: getPerf(support),
            options: { color: getPerfColor(support) },
          },
          {
            label: 'Niveau de risque',
            value: getRisk(support),
            options: { color: getRiskColor(support) },
          },
        ]"
        (onSelect)="onSupportSelect(support)"
        (onDeselect)="onSupportDeselect(support)"
        [withMoreInfoAnchor]="support.id"
        (onMoreInfoClick)="onMoreInfoClick(support)"
      >
      </pr-form-select-list-option>
    }
  </pr-form-select-list>
  <mat-paginator
    [length]="supportsLength"
    [pageSize]="supportsPageSize"
    (page)="changeSupportsPage($event)"
  >
  </mat-paginator>
  <div [class]="'one-button'">
    <pr-button
      display="neutral"
      size="lg"
      title="Valider"
      label="Valider"
      (onClick)="validateAddSupport()"
    ></pr-button>
  </div>
</pr-modal>
